import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import { TemplateConfigState } from './TemplateConfig.types';

const initialState: Partial<TemplateConfigState> = {};
const TemplateConfig = createSlice({
  name: 'TemplateConfig',
  initialState,
  reducers: {
    updateData: (state, action) => {
      let tempState = JSON.parse(JSON.stringify(state));
      if (tempState.layout.coordinator.steps.length > action.payload.step) {
        tempState.layout.coordinator.steps[action.payload.step].progressVisible = action.payload.completed;
      }
      tempState.layout.coordinator.currentStep = action.payload.step + 1;
      return tempState;
    },
    showAdverseActionPage: (state, action) => {
      let tempState = JSON.parse(JSON.stringify(state));
      tempState.layout.coordinator.steps = [action.payload];
      return tempState;
    },
    updateTemplateConfig: (state, action) => {
      return { ...state, ...JSON.parse(JSON.stringify(action.payload)) };
    },
    updateGlanceSettings: (state, action) => {
      return {
        ...state,
        glanceSettings: {
          ...state.glanceSettings,
          ...action.payload,
        },
      };
    },
    resetState: (_state) => {
      return initialState;
    },
  },
});

export const { updateData, updateGlanceSettings } = TemplateConfig.actions;

export const selectIsPropertyInTrustQuestionEnabled = (state: RootState) =>
  state.TemplateConfig?.features?.propertyInTrustQuestion?.isEnabled === true && state.TemplateConfig?.isICE !== true;

export default TemplateConfig.reducer;
